import { render, staticRenderFns } from "./ConferenceDate.vue?vue&type=template&id=68742e6a&"
import script from "./ConferenceDate.vue?vue&type=script&lang=ts&"
export * from "./ConferenceDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports